const BillDiff = props => (
    <div className={props.containerClass} onClick={props.onClick} data-protype={props.proType}>
        <div className={props.countClass}>{props.billCount || "-"}</div>
        { props.children }
    </div>
)

const TotalBillDiff = props => (
    <div className={props.className} onClick={props.onClick}>
        <span>{props.billCount}</span>
        { props.children }
    </div>
)

export {BillDiff, TotalBillDiff};